/** Colunas do order by da pesquisa das áreas */
export enum AreaSearchOrderBy {
    Codigo = 1,
    Nome = 2,
    Situacao = 3
};
